import * as React from 'react'
import { createSvgIcon } from '@mui/material/utils'

const Link = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 3C9.65685 3 11 4.34315 11 6H13C14.6569 6 16 7.34315 16 9V10C16 11.6569 14.6569 13 13 13H8C6.34315 13 5 11.6569 5 10H3C1.34315 10 0 8.65685 0 7V6C0 4.34315 1.34315 3 3 3H8ZM6 10C6 11.1046 6.89543 12 8 12H13C14.1046 12 15 11.1046 15 10V9C15 7.89543 14.1046 7 13 7H11C11 8.65685 9.65685 10 8 10H6ZM10 7H8C6.89543 7 6 7.89543 6 9H8C9.10457 9 10 8.10457 10 7ZM10 6H8C6.34315 6 5 7.34315 5 9H3C1.89543 9 1 8.10457 1 7V6C1 4.89543 1.89543 4 3 4H8C9.10457 4 10 4.89543 10 6Z"
  />,
  'Link'
)

export default Link
